// ABOUTME: React view of the colour theme — the viewer's choice, what it resolves to, and the setter.
// ABOUTME: Re-renders on a switch from the settings, the OS (in system mode) or another tab.

import { useSyncExternalStore } from "react"
import type { ThemePreference, ThemeState } from "./theme"
import { getThemeSnapshot, setThemePreference, subscribeTheme } from "./theme"

export interface UseTheme extends ThemeState {
  setPreference: (preference: ThemePreference) => void
}

export function useTheme(): UseTheme {
  const state = useSyncExternalStore(subscribeTheme, getThemeSnapshot, getThemeSnapshot)
  return { ...state, setPreference: setThemePreference }
}
